module.exports = __webpack_public_path__ + "img/ball-portrait-x2.dea920a9.jpg";